import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const Wrapper = styled.div`
  display: flex;
  padding: 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  z-index: 1;

  background: linear-gradient(${colors.verseNavBlue}, ${colors.verseNavBlue})
      padding-box,
    linear-gradient(to right, #141d2b, #273953, #141d2b) border-box;
  border-radius: 12px;
  border: 1px solid transparent;

  ${media.sm`
    width: 480px;
    margin: -100px auto auto;
  `}
`;

export const TitleWrapper = styled.div`
  padding: 16px 24px;
  text-align: center;

  & > * + * {
    margin-top: 16px;
  }

  ${media.sm`
    max-width: 250px;
  `}
`;

export const StyledImage = styled.img`
  height: 150px;
  margin-bottom: 16px;
`;
